// extracted by mini-css-extract-plugin
export var contentBody = "_c6-9";
export var headerImage = "_c6-2";
export var imageButton = "_c6-7";
export var imageButtonIcon = "_c6-8";
export var imageHeader = "_c6-4";
export var imageHeaderText = "_c6-5";
export var imageOverlay = "_c6-3";
export var imageTitle = "_c6-6";
export var imageWrapper = "_c6-1";
export var taskList = "_c6-a";
export var widget = "_c6-0";